<!-- block that hides the rest of the page on scroll-->
<!-- <div class="fixed top-0 w-full z-40"
  [ngClass]="{'bg-primary-light': look === 'light', 'bg-primary': look === 'primary', 'bg-white': look === 'white'}"
  [style.padding-top.px]="safeAreaTop" [style.height.px]="64 + safeAreaTop">
  <div class="flex flex-col pt-8">
    Safe Area Top: {{ safeAreaTop }}px
    Safe Area Bottom: {{ safeAreaBottom }}px
  </div>
</div> -->

<!-- gradient bar -->
<div class="bg-gradient-to-b from-[33%] to-transparent to-[100%] fixed top-0 left-0 right-0 w-full z-[9999]"
  [ngClass]="{'from-primary-light': look === 'light', 'from-primary': look === 'primary', 'from-white': look === 'white'}"
  [style.height.px]="safeAreaTop + 12"></div>

<!-- background color + "padding" -->
<div [style.height.px]="safeAreaTop + 8" class="w-full"
  [ngClass]="{'bg-primary-light': look === 'light', 'bg-primary': look === 'primary', 'bg-white': look === 'white'}">
</div>